/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {MaterialFunctionId} from "./materialFunctionId.zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const MaterialFunctionRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.material-functions"]),
    resourceId: MaterialFunctionId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type MaterialFunctionRealtimeChange = zod.input<typeof MaterialFunctionRealtimeChange>;
export type MaterialFunctionRealtimeChangeOutput = zod.output<
  typeof MaterialFunctionRealtimeChange
>;
